import SiteText from "./SiteText";

const Gratitude = (props) => {
    const {className} = props;
    return <div className={`rounded-xl m-6 p-6 bg-secondary/75 w-full lg:w-1/2 h-[70vh] flex flex-col justify-center items-center text-center ${className}`}>
        <div className="text-5xl m-4">
            {SiteText.Gratitude[0]}
        </div>
        <div className="text-2xl m-4">
            {SiteText.Gratitude[1]}
        </div>
    </div>
}

export default Gratitude;